/**
 * The type to describe the media type of the Transceiver
 */
export const TRANSCEIVER_MEDIA_TYPES = ['audio', 'video'] as const;
export type TransceiverMediaType = (typeof TRANSCEIVER_MEDIA_TYPES)[number];

export const CAN_SET_STREAMS =
    typeof RTCRtpSender !== 'undefined' &&
    'setStreams' in RTCRtpSender.prototype;
